/**
 * @author Praveen Varma
 * @description API Endpoints
 */
export const APIS = {
  LOGIN_API: "/api/login",
  SIGNUP_API: "/api/signup",
  FORGOT_PASSWORD_API: "/api/forgotpassword",
  CREATE_ROOM:"/api/create-room",
  JOIN_ROOM:"/api/validateRoom"
}
